import { Feature } from 'src/app/modules/feature-toggle/enums/features.enum';

/**
 * Wo schaltet man das Settings-Haekchen einer Funktion frei?
 * Route + onboardingAnchor existieren bereits auf den Settings-Seiten.
 * Eine Zeile pro gate-barer Funktion — einmal gepflegt, gilt fuer JEDE Anleitung,
 * die diese Funktion voraussetzt (generischer Preflight).
 */
export interface SettingsDeepLink {
  /** App-interne Route der Settings-Seite, z.B. '/settings/shift'. */
  route: string;
  /** onboardingAnchor-ID des Toggles auf dieser Seite (fuer Spotlight). */
  anchor: string;
}

export const FEATURE_SETTINGS_DEEPLINKS: Partial<Record<Feature, SettingsDeepLink>> = {
  [Feature.SHIFT_PLANNING_BASIC]: { route: '/settings/shift', anchor: 'shift-settings-active' },
  [Feature.SHIFT_PLANNING_TEMPLATES]: { route: '/settings/shift', anchor: 'shift-settings-active' },
  [Feature.SHIFT_PLANNING_AI]: { route: '/settings/shift', anchor: 'shift-settings-active' },
  [Feature.TIME_TRACKING_BASIC]: { route: '/settings/time-tracking', anchor: 'tt-active-toggle' },
  [Feature.TIME_TRACKING_MOBILE]: { route: '/settings/time-tracking', anchor: 'tt-active-toggle' },
  [Feature.TIME_TRACKING_TERMINAL]: { route: '/settings/terminal', anchor: 'terminal-enable-toggle' },
  [Feature.OVERTIME_MANAGEMENT]: { route: '/settings/time-tracking', anchor: 'tt-active-toggle' },
  [Feature.FLEXTIME]: { route: '/settings/time-tracking', anchor: 'tt-active-toggle' },
};

/**
 * Fallback-Zuordnung tourKey → benoetigte Funktion, solange das Backend-Feld
 * `requiresFeature` (Phase 6) noch nicht gepflegt ist. Wird vom Preflight nur
 * genutzt, wenn die Antwort kein explizites requiresFeature mitliefert.
 */
export const TOUR_KEY_FEATURE: Record<string, Feature> = {
  'shift-planning': Feature.SHIFT_PLANNING_BASIC,
  'staffing-management': Feature.SHIFT_PLANNING_BASIC,
  'time-recording': Feature.TIME_TRACKING_BASIC,
};
